import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const ProjectsTimelineChart = ({ data }) => {
  console.log("📋 ProjectsTimelineChart received:", data);

  // Extract project milestones from API response
  const projects = data.project_milestones || [];

  // Count projects by status (handle both Spanish and English)
  const statusCounts = {
    'Active': 0,
    'Completed': 0,
    'Pending': 0,
    'Cancelled': 0
  };

  // Map Spanish statuses to English
  const statusMap = {
    'Activo': 'Active',
    'Active': 'Active',
    'In Progress': 'Active',
    'En Progreso': 'Active',

    'Terminado': 'Completed',
    'Completed': 'Completed',
    'Complete': 'Completed',
    'Finalizado': 'Completed',

    'Pendiente': 'Pending',
    'Pending': 'Pending',
    'En Espera': 'Pending',
    'On Hold': 'Pending',

    'Cancelado': 'Cancelled',
    'Cancelled': 'Cancelled',
    'Canceled': 'Cancelled'
  };

  projects.forEach(project => {
    const rawStatus = project.status || 'Unknown';
    const normalizedStatus = statusMap[rawStatus];

    if (normalizedStatus && statusCounts.hasOwnProperty(normalizedStatus)) {
      statusCounts[normalizedStatus]++;
    }
  });

  console.log("📋 Status counts:", statusCounts);
  
  const statuses = ['Active', 'Completed', 'Pending', 'Cancelled'];
  const colors = {
    'Active': 'rgba(75, 192, 192, 0.7)',
    'Completed': 'rgba(54, 162, 235, 0.7)',
    'Pending': 'rgba(255, 206, 86, 0.7)',
    'Cancelled': 'rgba(255, 99, 132, 0.7)'
  };

  const chartData = {
    labels: statuses,
    datasets: [
      {
        label: 'Number of Projects',
        data: statuses.map(status => statusCounts[status] || 0),
        backgroundColor: statuses.map(status => colors[status]),
        borderColor: statuses.map(status => colors[status].replace('0.7', '1')),
        borderWidth: 1
      }
    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: true,
    aspectRatio: 1.5,
    plugins: {
      legend: {
        display: false
      },
      tooltip: {
        callbacks: {
          label: function(context) {
            return 'Projects: ' + context.parsed.y;
          }
        }
      }
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          stepSize: 1,
          precision: 0
        },
        grid: {
          color: 'rgba(0, 0, 0, 0.05)'
        }
      },
      x: {
        grid: {
          display: false
        }
      }
    }
  };

  // Handle no data case
  if (projects.length === 0) {
    return (
      <div style={{ position: 'relative', height: '350px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <p className="text-muted">No project data available for this period</p>
      </div>
    );
  }

  return (
    <div style={{ position: 'relative', height: '350px' }}>
      <Bar data={chartData} options={options} />
    </div>
  );
};

export default ProjectsTimelineChart;